import { MRT_ColumnDef, MRT_SortingState } from 'material-react-table';
import { BikeleasingContractListItemDTO, BikeleasingContractListItemDTOStatusEnum } from 'probonio-shared-ui/api';
import {
  ACTIVE_BIKELEASING_CONTRACT_STATUSES,
  ALL_BIKELEASING_CONTRACT_STATUSES,
  INACTIVE_BIKELEASING_CONTRACT_STATUSES,
} from 'probonio-shared-ui/utils/bikeleasingContractStatus';
import { useMemo } from 'react';
import { mapSortModel } from '../../../../component/table/sortMapper';
import { ContractFilterState } from '../contractFilterState';
import { filterAndSortBikeleasingContracts } from './bikeleasingContractsFilter';

export const useBikeleasingContractsViewModel = (
  contracts: BikeleasingContractListItemDTO[],
  filterState: ContractFilterState,
  columns: MRT_ColumnDef<BikeleasingContractListItemDTO>[],
  sorting: MRT_SortingState,
) => {
  const sortBy = useMemo(() => mapSortModel(columns, sorting), [columns, sorting]);

  const activeBase = useMemo(() => contracts.filter(c => c.status && ACTIVE_BIKELEASING_CONTRACT_STATUSES.includes(c.status)), [contracts]);

  const inactiveBase = useMemo(
    () => contracts.filter(c => c.status && INACTIVE_BIKELEASING_CONTRACT_STATUSES.includes(c.status)),
    [contracts],
  );

  /* We filter here against ALL_BIKELEASING_CONTRACT_STATUSES because ALL_BIKELEASING_CONTRACT_STATUSES has not really all statuses.
  So to keep the count of active + inactive = all we exclude the missing statuses in ALL_BIKELEASING_CONTRACT_STATUSES
   */
  const allBase = useMemo(() => contracts.filter(c => c.status && ALL_BIKELEASING_CONTRACT_STATUSES.includes(c.status)), [contracts]);

  const makeFiltered = (base: BikeleasingContractListItemDTO[], statuses?: BikeleasingContractListItemDTOStatusEnum[]) =>
    filterAndSortBikeleasingContracts({
      contracts: base,
      statuses,
      searchText: filterState.debouncedFilter.searchText,
      sortBy,
    });

  const activeContracts = makeFiltered(activeBase, filterState.filter.selectedStatus && [filterState.filter.selectedStatus]);
  const inactiveContracts = makeFiltered(inactiveBase, filterState.filter.selectedStatus && [filterState.filter.selectedStatus]);
  const allContracts = makeFiltered(allBase, filterState.filter.selectedStatus && [filterState.filter.selectedStatus]);

  return {
    activeContracts,
    inactiveContracts,
    allContracts,
  };
};
